import React from "react";
import styled from "styled-components";

interface IProps {
  invitationData: {
    invitationsAccepted: number;
    invitationsFinalized: number;
  };
}

const Container = styled.div`
  background-color: #2c2c2c;
  border-radius: 20px;
  padding: 20px;
  height: fit-content;
`;

const Title = styled.p`
  color: white;
  font-weight: 700;
  font-size: 20px;
  text-align: center;
  letter-spacing: 1px;
  margin-bottom: 20px;
`;

const StepContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-top: 20px; */
`;

const StepTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const StepTitle = styled.p`
  color: white;
  font-size: 16px;
`;

const StepNumber = styled.p`
  color: white;
  font-size: 22px;
  font-weight: 700;
`;

export const ReferralStatistics = (props: IProps) => {
  return (
    <Container>
      <Title>SEUS CONVITES</Title>
      <StepContainer>
        <StepTitleContainer>
          <svg
            width="22"
            height="18"
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.86034 9.19464C10.9287 9.19464 12.6054 7.48914 12.6054 5.38529C12.6054 3.28144 10.9287 1.57593 8.86034 1.57593C6.79197 1.57593 5.11523 3.28144 5.11523 5.38529C5.11523 7.48914 6.79197 9.19464 8.86034 9.19464Z"
              stroke="white"
              stroke-width="1.91"
              stroke-miterlimit="10"
            />
            <path
              d="M1.79688 17.6461L2.39783 14.5809C2.69383 13.0579 3.4995 11.6862 4.67774 10.6994C5.85599 9.71249 7.33402 9.17136 8.86032 9.16807C10.383 9.17414 11.8566 9.71684 13.0301 10.7038C14.2037 11.6907 15.0046 13.0608 15.2967 14.5809L15.9063 17.6461M10.9419 8.54794C11.5055 8.93286 12.1615 9.1547 12.8395 9.18974C13.5175 9.22477 14.1921 9.07168 14.7912 8.74683C15.3903 8.42199 15.8913 7.93761 16.2407 7.3455C16.59 6.7534 16.7746 6.07584 16.7746 5.38529C16.7746 4.69474 16.59 4.01718 16.2407 3.42507C15.8913 2.83296 15.3903 2.34858 14.7912 2.02374C14.1921 1.69889 13.5175 1.5458 12.8395 1.58083C12.1615 1.61587 11.5055 1.83771 10.9419 2.22263"
              stroke="white"
              stroke-width="1.91"
              stroke-miterlimit="10"
            />
            <path
              d="M20.0869 17.6462L19.4772 14.5721C19.2954 13.6405 18.9206 12.7591 18.3778 11.9863C17.835 11.2135 17.1367 10.5672 16.3292 10.0903C15.5217 9.61344 14.6236 9.31695 13.6947 9.22057C12.7658 9.12419 11.8274 9.23013 10.9419 9.53134"
              stroke="white"
              stroke-width="1.91"
              stroke-miterlimit="10"
            />
          </svg>
          <StepTitle>Convites aceitos:</StepTitle>
        </StepTitleContainer>
        <StepNumber>{props?.invitationData?.invitationsAccepted || 0}</StepNumber>
      </StepContainer>
      <div
        style={{
          height: 30,
          width: 0,
          border: "1px solid white",
          marginLeft: 10,
        }}
      ></div>
      <StepContainer>
        <StepTitleContainer>
          <svg
            width="24"
            height="23"
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_18736_7809)">
              <path
                d="M20.5263 3.69725V3.19725H20.0263H18.9377C18.8492 3.19264 18.8177 3.16348 18.807 3.15184C18.7904 3.13384 18.7761 3.10305 18.7761 3.06273C18.7761 3.02242 18.7904 2.99168 18.8069 2.97373C18.8176 2.96214 18.849 2.93291 18.9378 2.92825H20.0263H20.5263V2.42825V1.3752C20.5305 1.3041 20.5544 1.28001 20.5666 1.26946C20.5874 1.25148 20.6273 1.23317 20.6815 1.23315C20.7357 1.23314 20.7755 1.25143 20.7963 1.26936C20.8085 1.27987 20.8324 1.30399 20.8367 1.3753V2.42821V2.92821H21.3367H22.4253C22.5138 2.93282 22.5453 2.96198 22.556 2.97363C22.5726 2.99163 22.5869 3.02243 22.5869 3.06275C22.5869 3.10306 22.5726 3.1338 22.5561 3.15175C22.5455 3.16336 22.514 3.19259 22.4252 3.19725H21.3367H20.8367V3.69725V4.75031C20.8324 4.8214 20.8086 4.84549 20.7964 4.85604C20.7755 4.87402 20.7356 4.89233 20.6815 4.89235C20.6273 4.89236 20.5875 4.87407 20.5667 4.85614C20.5545 4.84563 20.5306 4.82151 20.5263 4.7502V3.69725ZM1.26318 2.29409C1.27385 2.28249 1.30535 2.25326 1.39409 2.2486H1.7809H2.2809V1.7486V1.37519C2.2851 1.3041 2.30895 1.28001 2.32118 1.26946C2.34201 1.25148 2.38191 1.23317 2.43607 1.23315C2.49022 1.23314 2.53007 1.25143 2.55086 1.26936C2.56305 1.27987 2.58697 1.30398 2.59122 1.37529V1.7486V2.2486H3.09122H3.47812C3.56665 2.25321 3.59813 2.28237 3.60884 2.29402C3.6254 2.31202 3.63969 2.34282 3.6397 2.38314C3.63971 2.42345 3.62544 2.45419 3.60894 2.47214C3.59827 2.48374 3.56677 2.51298 3.47803 2.51764H3.09122H2.59122V3.01764V3.39104C2.58702 3.46214 2.56317 3.48623 2.55094 3.49678C2.5301 3.51475 2.49021 3.53307 2.43605 3.53308C2.3819 3.5331 2.34205 3.5148 2.32126 3.49688C2.30907 3.48637 2.28515 3.46225 2.2809 3.39094V3.01764V2.51764H1.7809H1.394C1.30547 2.51302 1.27399 2.48386 1.26328 2.47222C1.24672 2.45421 1.23243 2.42341 1.23242 2.3831C1.23241 2.34279 1.24668 2.31205 1.26318 2.29409ZM2.94208 19.7591V20.2591H3.44208H4.1799C4.2684 20.2637 4.29987 20.2928 4.31057 20.3044C4.32712 20.3224 4.34141 20.3532 4.34142 20.3936C4.34143 20.4339 4.32716 20.4646 4.31065 20.4826C4.29998 20.4942 4.26848 20.5234 4.17974 20.5281H3.44208H2.94208V21.0281V21.7413C2.93787 21.8124 2.91403 21.8365 2.9018 21.847C2.88096 21.865 2.84106 21.8833 2.78691 21.8833C2.73276 21.8834 2.69291 21.8651 2.67212 21.8471C2.65993 21.8366 2.63601 21.8125 2.63176 21.7412V21.0281V20.5281H2.13176H1.39401C1.30547 20.5235 1.27399 20.4943 1.26328 20.4827C1.24672 20.4647 1.23243 20.4339 1.23242 20.3936C1.23241 20.3532 1.24668 20.3225 1.26318 20.3045C1.27385 20.2929 1.30535 20.2637 1.3941 20.2591H2.13176H2.63176V19.7591V19.0458C2.63596 18.9747 2.65981 18.9507 2.67204 18.9401C2.69287 18.9221 2.73277 18.9038 2.78693 18.9038C2.84108 18.9038 2.88093 18.9221 2.90172 18.94C2.91391 18.9505 2.93783 18.9746 2.94208 19.0459V19.7591ZM21.2685 21.8471C21.2563 21.8366 21.2323 21.8125 21.2281 21.7412V21.3679V20.8679H20.7281H20.3412C20.2526 20.8633 20.2211 20.8341 20.2104 20.8225C20.1939 20.8045 20.1796 20.7737 20.1796 20.7334C20.1796 20.6931 20.1938 20.6623 20.2103 20.6444C20.221 20.6328 20.2525 20.6035 20.3412 20.5989H20.7281H21.2281V20.0989V19.7255C21.2323 19.6544 21.2561 19.6303 21.2684 19.6197C21.2892 19.6017 21.3291 19.5834 21.3833 19.5834C21.4374 19.5834 21.4773 19.6017 21.4981 19.6196C21.5102 19.6301 21.5342 19.6542 21.5384 19.7256V20.0989V20.5989H22.0384H22.4253C22.5138 20.6035 22.5453 20.6326 22.556 20.6443C22.5726 20.6623 22.5869 20.6931 22.5869 20.7334C22.5869 20.7737 22.5726 20.8044 22.5561 20.8224C22.5455 20.834 22.514 20.8632 22.4252 20.8679H22.0384H21.5384V21.3679V21.7413C21.5342 21.8124 21.5104 21.8365 21.4981 21.847C21.4773 21.865 21.4374 21.8833 21.3832 21.8833C21.3291 21.8834 21.2892 21.8651 21.2685 21.8471ZM20.4347 7.38099L20.4347 7.38105C20.4575 7.399 20.4722 7.42117 20.4797 7.4435C20.4871 7.46569 20.4877 7.48895 20.4816 7.5112L20.4816 7.51122L17.6746 17.7058C17.6675 17.7314 17.6511 17.7571 17.6243 17.7771C17.5972 17.7973 17.5618 17.8096 17.5236 17.8096H6.29569C6.25749 17.8096 6.22212 17.7973 6.195 17.7771C6.16814 17.7571 6.15172 17.7314 6.14469 17.7058L3.33769 7.51126C3.33769 7.51125 3.33769 7.51125 3.33769 7.51124C3.33157 7.48899 3.33216 7.46574 3.33958 7.44356C3.34705 7.42121 3.36182 7.39904 3.38456 7.38109L3.07475 6.98864L3.38457 7.38109C3.40746 7.36301 3.437 7.35047 3.46994 7.34694C3.5029 7.34341 3.53562 7.34931 3.56375 7.36291C3.56377 7.36292 3.56378 7.36293 3.5638 7.36294L8.59175 9.79769L9.03038 10.0101L9.25395 9.57704L11.7679 4.70745L11.768 4.70747L11.7704 4.70256C11.7892 4.66516 11.8334 4.63 11.9097 4.62999C11.9859 4.62998 12.03 4.6651 12.0488 4.70253L12.0488 4.70254L12.0513 4.70746L14.5654 9.57704L14.7889 10.0101L15.2276 9.79768L20.2555 7.36287L20.2555 7.36286C20.2837 7.34924 20.3164 7.34334 20.3493 7.34687C20.3823 7.35039 20.4118 7.36293 20.4347 7.38099ZM17.0203 17.5405H17.4012L17.5024 17.1732L17.9014 15.7237L18.0756 15.0909H17.4194H6.3999H5.74362L5.91784 15.7237L6.31696 17.1732L6.41809 17.5405H6.79902H17.0203ZM17.7688 14.8219H18.1497L18.2508 14.4547L19.805 8.81057L20.0978 7.74705L19.105 8.22782L14.7917 10.3165L14.7917 10.3165C14.7042 10.3589 14.6085 10.3182 14.575 10.2534L14.1307 10.4827L14.575 10.2534L12.3539 5.95134L11.9097 5.09077L11.4654 5.95134L9.24438 10.2534C9.21095 10.3181 9.11503 10.3588 9.02758 10.3165L4.71436 8.22782L3.72156 7.74706L4.01439 8.81056L5.56842 14.4546L5.66955 14.8219H6.05048H17.7688Z"
                fill="black"
                stroke="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_18736_7809">
                <rect
                  width="22.3545"
                  height="21.6502"
                  fill="white"
                  transform="translate(0.732422 0.733154)"
                />
              </clipPath>
            </defs>
          </svg>
          <StepTitle>Colegas que concluíram a assinatura:</StepTitle>
        </StepTitleContainer>
        <StepNumber>{props?.invitationData?.invitationsFinalized || 0}</StepNumber>
      </StepContainer>
    </Container>
  );
};
